import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import Icon, { IconName } from "src/components/Icon/Icon";
import "./FormDropdown.scss";

export interface IFormDropdownOption {
  key: string;
  value: any;
}

export interface IFormDropdownProps {
  label?: string;
  options: IFormDropdownOption[];
  placeholder?: string;
  selectedValue?: any;
  onChange: (value: any) => void;
}

const FormDropdown: React.FC<IFormDropdownProps> = ({
  label,
  options = [],
  placeholder = "Select",
  selectedValue,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find(option => option.value === selectedValue);

  const toggle = () => setIsOpen(!isOpen);
  const handleSelect = value => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className="form-dropdown">
      {label && <label className="form-dropdown__label">{label}</label>}
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle className="form-dropdown__toggle">
          <span className="form-dropdown__selected">{selectedOption ? selectedOption.key : placeholder}</span>
          <Icon name={IconName.ChevronDown} size="16px" />
        </DropdownToggle>
        <DropdownMenu>
          {options.map(option => (
            <DropdownItem
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={selectedValue === option.value ? "form-dropdown__item--selected" : ""}>
              {option.key}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default FormDropdown;
